var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.lob === "SI"
        ? [
            _c("tab-local-service", {
              ref: "tabLocalService",
              attrs: { context: _vm.context, action: _vm.action, from: "sales" }
            })
          ]
        : _vm._e(),
      _vm.lob === "SE"
        ? [
            _c("tab-warehouse-for-se", {
              ref: "tabWarehouseForSe",
              attrs: { context: _vm.context, action: _vm.action, from: "sales" }
            }),
            _c("tab-trucking-for-se", {
              ref: "tabTruckingForSe",
              staticStyle: { "margin-right": "20px" },
              attrs: { context: _vm.context, action: _vm.action, from: "sales" }
            })
          ]
        : _vm._e(),
      _vm.lob === "AE"
        ? [
            _c("tab-warehouse-trucking", {
              ref: "tabLocalService",
              attrs: { context: _vm.context, action: _vm.action }
            })
          ]
        : _vm._e(),
      _vm.lob === "AI"
        ? [
            _c("tab-local-service-for-ai", {
              ref: "tabLocalService",
              attrs: { context: _vm.context, action: _vm.action }
            })
          ]
        : _vm._e(),
      _vm.lob === "RE" || _vm.lob === "RI"
        ? [
            _c("tab-local-service", {
              ref: "tabLocalService",
              staticStyle: { "margin-right": "20px" },
              attrs: { context: _vm.context, action: _vm.action, from: "sales" }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }